import mixpanel from "mixpanel-browser";
import { useCallback } from "react";
import { appLog } from "utils/webview";

/**
 * Hook for sending Mixpanel events only.
 * For setting/identifying Mixpanel People profile properties, use useMixpanelPeople.
 */
export default function useMixpanelWeb(request: {
  params?: { [key: string]: string };
  eventName: string;
}) {
  const params = request.params ? request.params : {};

  const fetchData = useCallback(
    async (overrideParams?: { [key: string]: string }) => {
      try {
        console.log("[mixpanel web]", request);
        appLog(`[mixpanel web] ${JSON.stringify(request)}`);

        // Track the event. 호출 시점 params 를 병합해 동일 이벤트명에 동적 값을 실어 보낼 수 있다.
        mixpanel.track(request.eventName, { ...params, ...overrideParams });
      } catch (error) {
        console.error("error", error);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [request]
  );

  return fetchData;
}
